import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

import { Providers } from "./components/Providers";
import { MobileNotification } from "../../components/Notifications";
import { FormLayoutComponent } from "./components/FormLayoutComponent";
import { ERRORS_TYPE } from "../../utils/getErrorScreenIcons/constants";
import { getErrorScreensIcons } from "../../utils/getErrorScreenIcons/getErrorScreenIcons";
import { Header } from "../../components/Header";

export const FormLayoutContainer = ({
  children,
  screeningError,
  financeType,
  isIslamicBanking,
  errorCode
}) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Providers>
      <MobileNotification>
        <Header />
        <FormLayoutComponent
          errorCode={errorCode}
          errorIcon={getErrorScreensIcons(financeType, isIslamicBanking, ERRORS_TYPE.BLOCK_EDITING)}
          pathname={pathname}
          screeningError={screeningError}
        >
          {children}
        </FormLayoutComponent>
      </MobileNotification>
    </Providers>
  );
};

FormLayoutContainer.propTypes = {
  children: PropTypes.node,
  screeningError: PropTypes.shape({
    error: PropTypes.bool,
    message: PropTypes.string
  }),
  financeType: PropTypes.string,
  isIslamicBanking: PropTypes.bool,
  errorCode: PropTypes.string
};
